import React from 'react';
import { teamMembers, coreValues, aboutContent } from '../data';
import { AboutProps } from '../types';
import AboutPresentation from './AboutPresentation';

const AboutContainer: React.FC<AboutProps> = ({ 
  className, 
  id = 'about' 
}) => {
  return (
    <AboutPresentation
      id={id}
      heading={aboutContent.heading}
      description={aboutContent.description}
      teamMembers={teamMembers}
      coreValues={coreValues}
    />
  );
};

export default AboutContainer;